<template>
  <div class="min-h-screen bg-white">
    <!-- 헤더 -->
    <AppHeader title="파트너스센터" backTo="/" />

    <!-- 메인 콘텐츠 -->
    <main class="max-w-lg mx-auto px-5">
      <!-- 히어로 섹션 -->
      <section class="pt-6 pb-8">
        <div class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-500/10 rounded-full mb-5">
          <div class="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
          <span class="text-[13px] font-bold text-blue-600">분양 상담사 전용</span>
        </div>

        <h1 class="text-[30px] font-black text-slate-900 leading-[1.25] tracking-tight mb-4">
          물개에서<br/>더 많은 고객을<br/>만나보세요
        </h1>

        <p class="text-[15px] font-medium text-slate-500 leading-[1.7]">
          고객이 직접 상담사를 선택하는 새로운 방식.<br/>
          검증된 고객 DB로 영업 효율을 높이세요.
        </p>
      </section>

      <!-- 숫자 강조 섹션 -->
      <section class="py-6">
        <div class="grid grid-cols-3 gap-2">
          <div class="bg-slate-100 rounded-2xl py-5 text-center">
            <p class="text-[22px] font-black text-slate-900 tracking-tight">24h</p>
            <p class="text-[11px] font-bold text-slate-500 mt-1">DB 우선권</p>
          </div>
          <div class="bg-blue-600 rounded-2xl py-5 text-center">
            <p class="text-[22px] font-black text-white tracking-tight">100%</p>
            <p class="text-[11px] font-bold text-blue-100 mt-1">실 상담의향</p>
          </div>
          <div class="bg-slate-100 rounded-2xl py-5 text-center">
            <p class="text-[22px] font-black text-slate-900 tracking-tight">0원</p>
            <p class="text-[11px] font-bold text-slate-500 mt-1">가입비 무료</p>
          </div>
        </div>
      </section>

      <!-- 혜택 리스트 -->
      <section class="py-8">
        <h2 class="text-[18px] font-black text-slate-900 tracking-tight mb-6">
          왜 물개인가요?
        </h2>

        <div class="space-y-4">
          <div class="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
            <div class="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-[15px] font-bold text-slate-900">고객이 직접 선택해요</h3>
              <p class="text-[13px] font-medium text-slate-500 mt-0.5">
                프로필을 보고 원하는 상담사를 고릅니다
              </p>
            </div>
          </div>

          <div class="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
            <div class="w-12 h-12 bg-slate-900 rounded-2xl flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-[15px] font-bold text-slate-900">검증된 고객만 연결</h3>
              <p class="text-[13px] font-medium text-slate-500 mt-0.5">
                실제 상담 의향이 확인된 고객이에요
              </p>
            </div>
          </div>

          <div class="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
            <div class="w-12 h-12 bg-slate-900 rounded-2xl flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
              </svg>
            </div>
            <div class="flex-1">
              <h3 class="text-[15px] font-bold text-slate-900">강력한 영업 도구</h3>
              <p class="text-[13px] font-medium text-slate-500 mt-0.5">
                점프, 캠페인 등 다양한 도구를 제공해요
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 등록 절차 -->
      <section class="py-8 border-t border-slate-100">
        <h2 class="text-[18px] font-black text-slate-900 tracking-tight mb-6">
          등록 절차
        </h2>

        <div class="space-y-4">
          <div class="flex items-center gap-4">
            <div class="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-[13px] font-bold flex-shrink-0">1</div>
            <div class="flex-1">
              <p class="text-[15px] font-bold text-slate-900">기본 정보 입력</p>
            </div>
          </div>
          <div class="flex items-center gap-4">
            <div class="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center text-slate-500 text-[13px] font-bold flex-shrink-0">2</div>
            <div class="flex-1">
              <p class="text-[15px] font-bold text-slate-700">담당 현장 선택</p>
            </div>
          </div>
          <div class="flex items-center gap-4">
            <div class="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center text-slate-500 text-[13px] font-bold flex-shrink-0">3</div>
            <div class="flex-1">
              <p class="text-[15px] font-bold text-slate-700">명함 업로드</p>
            </div>
          </div>
          <div class="flex items-center gap-4">
            <div class="w-8 h-8 bg-slate-200 rounded-full flex items-center justify-center text-slate-500 text-[13px] font-bold flex-shrink-0">4</div>
            <div class="flex-1">
              <p class="text-[15px] font-bold text-slate-700">심사 완료 <span class="text-[13px] font-medium text-slate-400 ml-1">1~2일</span></p>
            </div>
          </div>
        </div>
      </section>

      <!-- 에러 메시지 -->
      <div v-if="errorMessage" class="mb-4">
        <p class="text-[14px] font-semibold text-red-500 text-center bg-red-50 py-3 rounded-xl">
          {{ errorMessage }}
        </p>
      </div>
    </main>

    <!-- 하단 CTA (고정) -->
    <div class="fixed bottom-0 left-0 right-0 z-50 bg-white safe-area-bottom">
      <div class="max-w-lg mx-auto px-5 pt-3 pb-4">
        <template v-if="isLoggedIn">
          <button
            @click="$router.push('/partners/register')"
            class="w-full py-4 bg-blue-600 text-white text-[16px] font-bold rounded-2xl text-center active:scale-[0.98] transition-transform"
          >
            파트너 등록하기
          </button>
        </template>
        <template v-else>
          <button
            @click="handleGoogleLogin"
            :disabled="isLoading"
            class="w-full py-4 bg-slate-900 text-white text-[16px] font-bold rounded-2xl flex items-center justify-center gap-2.5 active:scale-[0.98] transition-transform disabled:opacity-50 mb-3"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Google로 시작하기
          </button>
          <button
            @click="$router.push('/partners/login?tab=signup')"
            class="w-full py-4 bg-blue-600 text-white text-[16px] font-bold rounded-2xl text-center active:scale-[0.98] transition-transform"
          >
            이메일로 회원가입
          </button>
          <p class="text-center text-[13px] font-medium text-slate-400 mt-4">
            이미 계정이 있으신가요?
            <router-link to="/partners/login" class="text-blue-600 font-bold ml-1 underline underline-offset-2">로그인</router-link>
          </p>
        </template>
      </div>
    </div>

    <!-- 하단 여백 (CTA 높이만큼) -->
    <div class="h-44"></div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '@/composables/common/useAuth'
import AppHeader from '@/components/common/AppHeader.vue'

export default {
  name: 'PartnersIntroView',
  components: {
    AppHeader
  },
  setup() {
    const router = useRouter()
    const { isLoggedIn, loginWithGoogle, userProfile } = useAuth()

    const isLoading = ref(false)
    const errorMessage = ref('')

    const handleGoogleLogin = async () => {
      errorMessage.value = ''
      isLoading.value = true

      const result = await loginWithGoogle()

      if (result.success) {
        await new Promise(resolve => setTimeout(resolve, 500))

        if (userProfile.value?.role === 'partner' || userProfile.value?.role === 'admin') {
          router.push('/partners')
        } else {
          router.push('/partners/register')
        }
      } else {
        errorMessage.value = result.error
      }

      isLoading.value = false
    }

    return {
      isLoggedIn,
      isLoading,
      errorMessage,
      handleGoogleLogin
    }
  }
}
</script>

<style scoped>
.safe-area-bottom {
  padding-bottom: max(16px, env(safe-area-inset-bottom));
}
</style>
